import React from 'react'
import { Label, Radio  ,Flowbite} from 'flowbite-react';
import propTypes from 'prop-types';

export const CommonRadio = React.memo(({ title, steps , onChange}) => {

    const customTheme = {
        "radio": {
            "root": {
              "base": "h-4 w-4 border border-secondary-300 ring-0 focus:ring-0 dark:border-secondary-600 text-primary-400"
            }
          },
      };
    
    return (
        <fieldset id="radio">
            <legend className='text-xs font-normal text-secondary-500'>
                {title}
            </legend>
            <Flowbite theme={{ theme: customTheme }}>
            <div className="flex items-center gap-3 mt-3">
                {!!steps?.length && steps?.map(step => <div key={step.label} className='flex gap-2'>
                    <Radio
                        checked={step?.checked}
                        id={step?.label}
                        role="button"
                        onChange={onChange}
                        name={step?.label}
                        value={step?.value}
                    />
                    <Label htmlFor={step?.label}>
                        {step?.label}
                    </Label>
                </div>)}
            </div>
            </Flowbite>
        </fieldset>
    )
})

CommonRadio.propTypes = {
    title: propTypes.string,
    steps: propTypes.array
}

CommonRadio.defaultProps = {
    title: '',
    steps: []
}
